(function () {
    'use strict';

    angular
        .module('HRConfirmationsControllers', ['services.employeeSyncService']);
})();
